import { SelectOption } from '@/types/form.type.ts';

export enum CarTransmissionType {
    AT = 'AT',
    MT = 'MT',
    Robotized = 'robotized',
    Variator = 'variator',
}

export function getCarTransmissionTypeLabel(type: CarTransmissionType): string {
    switch (type) {
        case CarTransmissionType.AT:
            return 'Автомат';
        case CarTransmissionType.MT:
            return 'Механика';
        case CarTransmissionType.Robotized:
            return 'Робот';
        case CarTransmissionType.Variator:
            return 'Вариатор';
    }
}

export function getCarTransmissionTypeSelectOptions(): SelectOption[] {
    const options: SelectOption[] = [];

    Object.values(CarTransmissionType).forEach((type: CarTransmissionType) => {
        options.push({
            label: getCarTransmissionTypeLabel(type),
            value: type,
        });
    });

    return options;
}
